<app-user-access-form *appShellNoRender [enabled]="enabled" [params]="params" (onCloseForm)="handleEvent($event)" [isModalDisplay]="true" [isMainLogin]="true"></app-user-access-form>
